/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { ArticleCard } from 'modules/components'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'related-posts'

/**
 * This is the component description.
 */
const RelatedPosts = ({
  id,
  className:userClassName,
  style,
  items,
}) => (
  <ArticleCard.Group
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
    type="snap-scroller"
    desktopType="grid"
  >
    {items.map((node) => (
      <ArticleCard
        className="md-span-4 span-7 manual-mobile-only"
        node={node}
      />
    ))}
  </ArticleCard.Group>
)

RelatedPosts.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  List of posts to render
   */
  items:PropTypes.arrayOf(PropTypes.shape({
    title      :PropTypes.string,
    mainImage  :PropTypes.string,
    slug       :PropTypes.string,
    description:PropTypes.string,
  })),
}

RelatedPosts.defaultProps = {
  // someProp:false
}

export default RelatedPosts
